module.exports = __webpack_public_path__ + "static/media/testimonial_slide.becc5c8a.jpg";